import { render } from "./EditAppItem.vue?vue&type=template&id=049d022d"
import script from "./EditAppItem.vue?vue&type=script&lang=js"
export * from "./EditAppItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\lotus-Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__